export function getParam (paramName) {
  if (typeof URL !== 'undefined') {
    let url = new URL(window.location)
    return url.searchParams.get(paramName)
  }
  let val = window.location.search.match(new RegExp(`(\\?|&)${paramName}=([^&]*)`))
  if (val) {
    return decodeURIComponent(val[2])
  }
}



// WEBPACK FOOTER //
// ./src/lib/Params.js